// Web mock for react-native-bootsplash
const RNBootSplash = {
  hide: async (config?: { fade?: boolean }) => {},
  show: async () => {},
  getVisibilityStatus: async () => 'hidden' as const,
  isVisible: false,
};

export default RNBootSplash;
